module.exports = __webpack_public_path__ + "img/ICO_m_standard.ba139424.svg";